import axios from 'axios'
// 创建一个名为 ApiService 的对象，包含您的异步方法
const ApiService = {
	async triplet(articleId) {
		return await axios.get('http://43.139.90.182:8888/csdnArticleInfo/triplet?articleId=' + articleId)
	},
	async resetLikes() {
		return await axios.get('http://43.139.90.182:8888/csdnArticleInfo/fixLikesStatus')
	},
	async allTriplet(articleIds) {
		return await axios.post('http://43.139.90.182:8888/csdnArticleInfo/multiTriplet', articleIds)
	},
	async onDelete(id) {
		return await axios.get('http://43.139.90.182:8888/csdnArticleInfo/delete', {
			params: {
				id: id,
			},
		})
	},
}
export default ApiService
